module.exports = __webpack_public_path__ + "img/6508.0d4c215d.jpg";